import { SVGProps, Ref, forwardRef } from 'react';

export const RUSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <rect y={3} width={24} height={18} rx={3} fill="#DADADA" />
            <path d="M0 6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v3H0z" fill="#EEEEEE" />
            <rect y={9} width={24} height={6} fill="#22408C" />
            <path d="M0 15h24v3a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z" fill="#CE2028" />
        </g>
    </svg>
));
RUSize24Glyph.displayName = 'RUSize24Glyph';
